import { connect } from 'react-redux';
import FeePanel from './FeePanel';

const mapStateToProps = ({ siteInfo }) => ({
    siteInfo,
});

export default connect(mapStateToProps)(FeePanel);
